import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBoxOpen, FaShieldAlt, FaTruck } from 'react-icons/fa';
import frantoio from '../assets/frantoio.webp';
import mozzarella from '../assets/mozzarella.webp';
import camioncino from '../assets/camioncino.webp';
import { trackPartnerEvent } from '../hooks/useCandidaturaAnalytics';

const profiles = [
  { img: frantoio, label: 'Olio & conserve', categoria: 'Olio extravergine di oliva' },
  { img: mozzarella, label: 'Caseificio', categoria: 'Mozzarella di bufala' },
  { img: camioncino, label: 'Salumi & altro', categoria: 'Salumi artigianali' },
];

export default function PartnerCTASection() {
  return (
    <section className="bg-gradient-to-br from-[#fff8ea] to-[#FFFEFA] border-y border-[#f3deb8] py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <p className="text-xs uppercase tracking-widest text-[#c78244] font-semibold mb-2">
            Per produttori e partner
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-3">
            Sei produttore alimentare?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Formaggi, salumi, olio, pasta, conserve e altre eccellenze — catalogo curato per categoria e territorio
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-4 mb-8">
          {profiles.map((p, i) => (
            <motion.div
              key={p.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="mang-card overflow-hidden"
            >
              <img src={p.img} alt={p.label} className="w-full h-28 object-cover" />
              <div className="p-4 text-center">
                <p className="font-semibold text-gray-800">{p.label}</p>
                <Link
                  to={`/candidatura?categoria=${encodeURIComponent(p.categoria)}`}
                  onClick={() => trackPartnerEvent('partner_cta_click', { source: 'home_profile', categoria: p.categoria })}
                  className="text-sm text-[#c78244] underline mt-1 inline-block"
                >
                  Candidati →
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="grid sm:grid-cols-3 gap-4 text-center text-sm text-gray-600 mb-8">
          <div className="flex flex-col items-center gap-2">
            <FaBoxOpen className="text-2xl text-[#c78244]" />
            <span>Tutte le categorie alimentari</span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <FaShieldAlt className="text-2xl text-[#c78244]" />
            <span>Valutazione qualità inclusa</span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <FaTruck className="text-2xl text-[#c78244]" />
            <span>Logistica gestita in piattaforma</span>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/diventa-partner"
            onClick={() => trackPartnerEvent('partner_cta_click', { source: 'home_primary' })}
            className="bg-gradient-to-r from-[#F6CF48] to-[#c78244] text-white px-8 py-3 rounded-full font-bold shadow-lg hover:opacity-95"
          >
            Scopri come candidarti
          </Link>
          <Link
            to="/per-partner"
            onClick={() => trackPartnerEvent('partner_cta_click', { source: 'home_brochure' })}
            className="border-2 border-[#c78244] text-[#c78244] px-8 py-3 rounded-full font-bold hover:bg-[#c78244]/5"
          >
            Modello per partner
          </Link>
          <Link
            to="/candidatura"
            onClick={() => trackPartnerEvent('partner_cta_click', { source: 'home_direct' })}
            className="border-2 border-gray-300 text-gray-700 px-8 py-3 rounded-full font-bold hover:bg-gray-50"
          >
            Inizia in 2 minuti
          </Link>
        </div>
      </div>
    </section>
  );
}
